import { render, staticRenderFns } from "./OrderFinishOrRejectDialog.vue?vue&type=template&id=767b99cf&scoped=true"
import script from "./OrderFinishOrRejectDialog.vue?vue&type=script&lang=js"
export * from "./OrderFinishOrRejectDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderFinishOrRejectDialog.vue?vue&type=style&index=0&id=767b99cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767b99cf",
  null
  
)

export default component.exports